module.exports = __webpack_public_path__ + "img/Icon-Help.4a30b47d.svg";